interface Config<ValueType> {
  pollInterval: number
  pollTimes: number
  getValue: () => Promise<ValueType>
  fn: () => void
  callBackAfter?: (cb: () => void, timeout: number) => void
  isEqual: (value1: ValueType, value2: ValueType) => boolean
}

export const createCallFunctionWhenValueChanges = () => {
  let isPolling: boolean
  let pollsLeft: number
  let concurrentCalls: number

  const reset = () => {
    isPolling = false
    concurrentCalls = 0
  }

  reset()

  const callFunctionWhenValueChanges = <ValueType>({
    pollInterval,
    pollTimes,
    getValue,
    fn,
    callBackAfter = setTimeout,
    isEqual,
  }: Config<ValueType>) => {
    pollsLeft = pollTimes
    concurrentCalls++
    if (isPolling) {
      return
    }
    isPolling = true

    const poll = (initialValue: ValueType) => {
      if (pollsLeft === 0 || concurrentCalls === 0) {
        reset()
        return
      }
      pollsLeft--
      callBackAfter(
        () =>
          getValue().then(value => {
            if (!isEqual(value, initialValue)) {
              fn()
              concurrentCalls--
            }
            poll(value)
          }),
        pollInterval,
      )
    }

    getValue().then(poll)
  }

  return callFunctionWhenValueChanges
}
